import { InferType, array, date, object, string } from "yup";
import { DocumentSchema } from "./document";

export enum TaskManualStatus {
    TODO = "TODO",
    IN_PROGRESS = "IN_PROGRESS",
    DONE = "DONE",
}

export enum TaskOwnerType {
    DEVICE = "DEVICE",
    ORGANIZATION = "ORGANIZATION",
}

// Simplified assignee schema (subset of user fields)
export const taskAssigneeSchema = object({
    id: string().uuid().required(),
    email: string().email().required(),
    firstName: string().required(),
    lastName: string().required(),
});

export type TaskAssignee = InferType<typeof taskAssigneeSchema>;

// Note: taskConfig is accessed via TaskDefinition, not directly on TaskState
export const taskStateSchema = object({
    id: string().uuid().required(),
    taskKey: string().required(),
    ownerType: string()
        .oneOf([
            TaskOwnerType.DEVICE,
            TaskOwnerType.ORGANIZATION,
        ])
        .required(),
    ownerId: string().uuid().required(),
    organizationId: string().uuid().required(),
    deviceId: string().uuid().nullable().optional(),
    assigneeId: string().uuid().nullable().optional(),
    assignee: taskAssigneeSchema.nullable().optional(),
    dueDate: date().nullable().optional(),
    manualStatus: string()
        .oneOf([
            TaskManualStatus.TODO,
            TaskManualStatus.IN_PROGRESS,
            TaskManualStatus.DONE,
        ])
        .required(),
    notesDocumentId: string().uuid().nullable().optional(),
    notesDocument: DocumentSchema.nullable().optional(),
    fileDocuments: array().of(DocumentSchema).optional(),
    createdBy: string().uuid().required(),
    createdAt: date().required(),
    updatedAt: date().required(),
});

export type TaskState = InferType<typeof taskStateSchema>;

export const taskStatesSchema = array().of(taskStateSchema);

export type TaskStates = InferType<typeof taskStatesSchema>;
